export class ContactMessage {
  
    // Data model

    constructor(public name: string,
                public email: string,
                public phoneNumber: string,
                public dateEvent: string,         
                public message: string) {
    }


  }